import React from 'react';
import { toast } from 'sonner';
import { DirectionsIntentModal } from '../components/guest-map/GuestMapSurface';

// Ad-hoc trigger that reaches into the module bus without going through the
// map surface — mirrors what a real "Get directions" tap would emit.
function fakeTapGetDirections() {
  // Programmatically drive the same import path the real buttons use.
  // We can't import the private `openDirections` fn directly, so we drop a
  // temporary `venue` snapshot into localStorage and dispatch a custom
  // window event. The modal doesn't listen to window events — it uses a
  // module-scoped Set — so instead we call the module bus via a small
  // re-export. See below.
}

// Because `openDirections` is not exported from GuestMapSurface (private),
// we bounce through a small `__triggerDirectionsIntent` shim also exported
// from that file. See surface.js for the export.
import { __triggerDirectionsIntent } from '../components/guest-map/GuestMapSurface';

const SAMPLE_VENUES = [
  { id: 'venue-001', name: 'Taverna Opa', latitude: 39.6243, longitude: 19.9217, address: 'Corfu Town' },
  { id: 'venue-002', name: 'Cafe Verde', latitude: 39.62, longitude: 19.92, address: 'Old Port' },
];

/**
 * /dev/directions-intent — mounts the "Give the venue a heads-up?" bottom
 * sheet in isolation. Used to verify the layout + copy + the two-choice
 * flow without needing the full guest map (which requires geolocation
 * permission we can't grant in Playwright).
 */
export default function DirectionsIntentPreview() {
  const font = "'Inria Serif', serif";
  const buttonStyle = {
    padding: '12px 18px',
    borderRadius: 16,
    border: 'none',
    cursor: 'pointer',
    background: '#5544CC',
    color: '#fff',
    fontFamily: font,
    fontSize: 14,
    fontWeight: 700,
  };
  const openWith = (venue) => {
    __triggerDirectionsIntent(venue);
    toast.info(`Opened intent modal for: ${venue.name}`);
  };
  return (
    <div style={{ minHeight: '100vh', padding: 24, background: 'var(--bg, #f5f5f7)', fontFamily: font }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111', margin: 0 }}>Directions Intent Preview</h1>
      <p style={{ marginTop: 6, color: '#555', fontSize: 14, lineHeight: 1.5 }}>
        Tapping a venue below shows the same bottom sheet the guest sees on the map
        when they tap "Get directions". Confirm the flow, then delete this route.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 20 }}>
        {SAMPLE_VENUES.map((v) => (
          <button
            key={v.id}
            type="button"
            data-testid={`directions-preview-trigger-${v.id}`}
            style={buttonStyle}
            onClick={() => openWith(v)}
          >
            Tap "Get directions" for {v.name}
          </button>
        ))}
      </div>
      <DirectionsIntentModal />
    </div>
  );
}
